import React from "react";
import { Link } from "react-router-dom";
import { LOGO } from "@/data/media";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-brand-black text-white">
      <div className="absolute inset-0 dot-grid-dark opacity-30 pointer-events-none" aria-hidden />
      <div className="relative mx-auto max-w-[1360px] px-5 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link">
              <span className="relative inline-flex h-12 w-12 items-center justify-center overflow-hidden">
                <img
                  src={LOGO.markDark}
                  alt="LotWise Home"
                  className="h-full w-full object-contain scale-[1.85]"
                  draggable={false}
                />
              </span>
              <span className="text-[22px] font-bold tracking-[-0.01em] leading-none">
                LotWise <span className="text-brand-gray font-medium">| Home</span>
              </span>
            </Link>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-white/60">
              Real estate listing support handled as a system. Property photos, listing details, and
              presentation materials prepared to a stronger standard for agents, teams, and brokerages
              across southeastern Ontario.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 rounded-full border border-white/15 px-4 py-2">
              <span className="h-1.5 w-1.5 rounded-full bg-brand-blue" />
              <span className="text-[12px] tracking-wide text-white/80">
                Currently serving southeastern Ontario · Waitlist open for other regions
              </span>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow text-white/50">Site</div>
            <ul className="mt-4 space-y-2 text-[14px]">
              <li><Link to="/" className="hover:text-brand-blue transition-colors">Home</Link></li>
              <li><Link to="/pricing" className="hover:text-brand-blue transition-colors">Pricing</Link></li>
              <li><Link to="/listing-standard" className="hover:text-brand-blue transition-colors">Listing Standard</Link></li>
              <li><Link to="/faq" className="hover:text-brand-blue transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow text-white/50">Company</div>
            <ul className="mt-4 space-y-2 text-[14px]">
              <li><Link to="/about" className="hover:text-brand-blue transition-colors">About</Link></li>
              <li><Link to="/insights" className="hover:text-brand-blue transition-colors">Insights</Link></li>
              <li><Link to="/contact" className="hover:text-brand-blue transition-colors">Request Support</Link></li>
              <li><Link to="/contact#service-area" className="hover:text-brand-blue transition-colors">Service Area</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-white/50">Legal</div>
            <ul className="mt-4 space-y-2 text-[14px]">
              <li><Link to="/privacy" className="hover:text-brand-blue transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-brand-blue transition-colors">Terms / Service Notes</Link></li>
            </ul>
            <div className="mt-6">
              <div className="eyebrow text-white/50">Contact</div>
              <a href="mailto:hello@lotwiseauto.ca" className="mt-3 block text-[14px] hover:text-brand-blue transition-colors" data-testid="footer-email-link">
                hello@lotwiseauto.ca
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-[12px] text-white/50">
          <div className="tracking-tight">
            © {new Date().getFullYear()} LotWise Home. Handled as a system. Presented properly.
          </div>
          <div>
            Website created by{" "}
            <a
              href="https://kostaja.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-brand-blue transition-colors link-underline"
              data-testid="footer-kostaja-link"
            >
              Kostaja
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
